import * as yup from "yup";

export const ReimbursementsSetupValidationSchema = yup.object().shape({
  label: yup
    .string()
    .required("Reimbursement Label is required")
    .max(20, "Maximum length 20 characters"),
    maxYtd: yup
    .string()
    // .typeError("Must be a valid number")
    .max(99999999.99, "Value cannot exceed 99999999.99"),
});
